import { ContentMaster } from './ContentMaster.model';
import { CourseMaster } from './CourseMaster.model';
import { StudentMaster } from './StudentMaster.model';

export class CartMaster {
    public cartMasterId:number;
    public courseMaster:CourseMaster;
    public courseMasterId:number;
    public studentMaster:StudentMaster;
    public studentMasterId:number;
    public isDelete:string;
}